import { useState } from 'react';
import { usePermissions } from '../hooks/usePermissions';
import GivingDashboard from './PastorsTools/GivingDashboard';
import { Banner, Card, EmptyState, PageBody, PageHeader, cx } from './ui';

const TABS = [
    { key: 'giving', label: 'Online giving' },
    { key: 'purchase-orders', label: 'Purchase orders' },
];

const Tabs = ({ active, onChange }) => (
    <div className="-mb-px flex gap-1 overflow-x-auto">
        {TABS.map((tab) => (
            <button
                key={tab.key}
                type="button"
                onClick={() => onChange(tab.key)}
                className={cx(
                    'whitespace-nowrap border-b-2 px-3 py-2 text-sm font-medium transition-colors',
                    active === tab.key
                        ? 'border-brand-700 text-brand-800'
                        : 'border-transparent text-neutral-500 hover:border-neutral-300 hover:text-neutral-800'
                )}
            >
                {tab.label}
            </button>
        ))}
    </div>
);

export const Finance = () => {
    const { canAccess, loading } = usePermissions();
    const [tab, setTab] = useState('giving');

    if (loading) {
        return (
            <>
                <PageHeader title="Finance" description="Online giving, and purchase orders." />
                <PageBody>
                    <Card>
                        <EmptyState title="Checking your access…" />
                    </Card>
                </PageBody>
            </>
        );
    }

    if (!canAccess('Finance')) {
        return (
            <>
                <PageHeader title="Finance" description="Online giving, and purchase orders." />
                <PageBody>
                    <Banner tone="danger" title="You don't have access to Finance">
                        This area is for the finance office. Ask an administrator to give you the Finance role
                        under Administrator → People.
                    </Banner>
                </PageBody>
            </>
        );
    }

    return (
        <>
            <PageHeader title="Finance" description="Online giving, and purchase orders.">
                <div className="mx-auto max-w-6xl px-4 pb-3 sm:px-6 lg:px-8">
                    <Tabs active={tab} onChange={setTab} />
                </div>
            </PageHeader>

            <PageBody className="space-y-4">
                {tab === 'giving' && <GivingDashboard canManageTypes={false} />}
                {tab === 'purchase-orders' && (
                    <Card>
                        <EmptyState
                            title="Purchase orders are coming"
                            description="This is where purchase orders will live once they're ready. For now, online giving is on the other tab."
                        />
                    </Card>
                )}
            </PageBody>
        </>
    );
};

export default Finance;
